var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageContent = function SvgMessageContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M20 19v26h24V19H20zm0-2h24a2 2 0 0 1 2 2v26a2 2 0 0 1-2 2H20a2 2 0 0 1-2-2V19a2 2 0 0 1 2-2zm5 7v3h3v-3h-3zm0-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2zm-1 16a1 1 0 0 1 0-2h16a1 1 0 0 1 0 2H24zm0-4a1 1 0 0 1 0-2h16a1 1 0 0 1 0 2H24zm0 8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2h-8z"
  })));
};
export default SvgMessageContent;